// Claude: Buyer Feedback admin page 26-03-2026
import React from "react";
import FeedbackPage from "./FeedbackPage";

const BuyerFeedback = () => <FeedbackPage role="Buyer" title="Buyer Feedback" />;
export default BuyerFeedback;
